import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import HeadingWithBadge from 'ui/HeadingWithBadge'
import Icon from 'ui/Icon'
import dynamicGridIcon from 'icons/dynamic_grid.svg'
import normalGridICon from 'icons/normal_grid.svg'
import smallGridIcon from 'icons/small_grid.svg'
import { BACKGROUNDS, COLORS } from 'themes'
import Button from 'ui/controls/Button'
import device from 'utils/mediaQueries'
import { HEADER_MOBILE_HEIGHT, TOPBAR_MOBILE_HEIGHT } from 'configs/ui'
import { ModalService } from 'services/ModalService'
import SmartFilterService from 'services/SmartFilterService'
import smoothscroll from 'smoothscroll-polyfill'
import SortButton from 'features/GridControls/SortButton'

const FlexWrapper = styled.div`
    display: flex;
    flex: 1 1 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
`

const GridIconsWrapper = styled.div`
    position: absolute;
    width: 144px;
    left: 0;
    right: 0;
    margin: 0 auto 20px;
    flex-direction: row;
    align-items: center;
    display: flex;
    @media screen and ${device.lg} {
        display: none;
    }
`
const GridIconWrapper = styled.div`
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 5px;
    transition: all 0.3s ease;
    background-color: ${({ active }) =>
        active ? BACKGROUNDS.white : BACKGROUNDS.grey300};
    body.hasHover &:hover {
        background-color: ${({ active }) =>
            active ? BACKGROUNDS.white : BACKGROUNDS.grey};
    }
    ${Icon} {
        background: ${({ active }) =>
            active ? BACKGROUNDS.secondary : BACKGROUNDS.white};
    }
`
const SortingControls = styled.div`
    margin-bottom: 20px;
    font-size: 16px;
    color: ${COLORS.white};

    @media screen and ${device.sm} {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 10px 0;
        position: fixed;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 5;
        background: ${BACKGROUNDS.black};
        transition: all 0.5s ease-in-out;
        top: ${({ hide }) =>
            hide
                ? '-50px'
                : `calc(${TOPBAR_MOBILE_HEIGHT} + ${HEADER_MOBILE_HEIGHT})`};
        ${Button} {
            margin: 5px;
            padding: 7px 15px;
            width: 90%;
        }
    }
`

const gridTypes = [
    { name: 'dynamic', icon: dynamicGridIcon },
    { name: 'normal', icon: normalGridICon },
    { name: 'small', icon: smallGridIcon },
]

const GridControls = ({
    category,
    gridType,
    setGridType,
    withFilter = false,
    gamesToMapAll = [],
    setGamesToMapAll,
    setGamesToMap,
    withSort = true,
    showSortAndFilter = false,
}) => {
    const [selectedFilters, setSelectedFilters] = useState([])
    const [hideOnScroll, setHideOnScroll] = useState(false)

    useEffect(() => {
        const SmartFilterSub = SmartFilterService.getFilters().subscribe(
            (filters) => {
                setSelectedFilters(filters)
            }
        )

        const onScroll = () => {
            smoothscroll.polyfill()
            window.__forceSmoothScrollPolyfill__ = true
            let scrollTop =
                window.pageYOffset || document.documentElement.scrollTop
            setHideOnScroll(scrollTop > 10)
        }

        window.document.addEventListener('scroll', onScroll)

        return () => {
            setSelectedFilters([])
            window.document.removeEventListener('scroll', onScroll)
            SmartFilterSub.unsubscribe()
        }
    }, [])

    useEffect(
        () => {
            SmartFilterService.setFilteredGames(gamesToMapAll.length || 0)
        },
        [gamesToMapAll, selectedFilters]
    )

    return (
        <FlexWrapper>
            <HeadingWithBadge bold>{category}</HeadingWithBadge>
            <GridIconsWrapper>
                {gridTypes.map((el) => (
                    <GridIconWrapper
                        key={el.name}
                        onClick={() => {
                            setGridType(el.name)
                        }}
                        active={gridType === el.name}
                    >
                        <Icon src={el.icon} width="18px" height="18px" />
                    </GridIconWrapper>
                ))}
            </GridIconsWrapper>
            {showSortAndFilter && (
                <SortingControls hide={hideOnScroll}>
                    {withSort && (
                        <SortButton
                            category={category}
                            gamesToMapAll={gamesToMapAll}
                            setGamesToMap={setGamesToMap}
                            setGamesToMapAll={setGamesToMapAll}
                            hideOnScroll={hideOnScroll}
                        />
                    )}
                    {withFilter ? (
                        <Button
                            onClick={() => {
                                ModalService.showModal('SMART_FILTERS')
                            }}
                            accent={selectedFilters.length}
                            black={!selectedFilters.length}
                            textsize="16px"
                            padding="5px 25px"
                        >
                            Smart filter
                        </Button>
                    ) : null}
                </SortingControls>
            )}
        </FlexWrapper>
    )
}
export default GridControls
